export const SCOPE_SEARCH_LIMIT = 10;

export const scopeItemKey = (kind, item) => `${kind}-${item._id}`;

// Page summaries carry no createdAt; an ObjectId starts with its creation time in seconds.
export const createdTime = item => {
  const time = item.createdAt
    ? Date.parse(item.createdAt)
    : parseInt(String(item._id).slice(0, 8), 16) * 1000;
  return Number.isNaN(time) ? 0 : time;
};

const newestFirst = (a, b) => b.time - a.time || (String(b.item._id) > String(a.item._id) ? 1 : -1);

/**
 * Each list loads `SCOPE_SEARCH_LIMIT` at a time. The nth load of every list is sorted together
 * and goes below the previous ones, so rows already on screen never move.
 */
export const mergeScopeResults = (sources, pickedKeys = new Set()) => {
  const loads = Math.max(0, ...sources.map(source => source.batches.length));
  const seen = new Set();

  return Array.from({ length: loads }, (_, index) =>
    sources
      .flatMap(({ kind, batches }) =>
        (batches[index] ?? []).map(item => ({
          kind,
          item,
          key: scopeItemKey(kind, item),
          time: createdTime(item),
        })),
      )
      .sort(newestFirst),
  )
    .flat()
    .filter(row => {
      if (seen.has(row.key)) return false;
      seen.add(row.key);
      return !pickedKeys.has(row.key);
    });
};
